<ng-container *ngIf="windowHash">
  <sub-header [isModal]="true" [windowHash]="windowHash"></sub-header>
  <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1" *ngIf="loaded">
    <ng-container *ngTemplateOutlet="criterialListTemplate"></ng-container>
  </p-scrollPanel>
</ng-container>
<div class="wrapper wrapper-content" *ngIf="!windowHash && loaded">
  <ng-container *ngTemplateOutlet="criterialListTemplate"></ng-container>
</div>
<ng-template #criterialListTemplate>
  <div class="container-fluid">
    <div class="row m-t-md" *ngFor="let lot of getLots()">
      <ng-container
        *ngTemplateOutlet="criterialLotTemplate;context: { tableData: lotCriteriaData.get(lot.lotId) ,lot: lot}">
      </ng-container>
    </div>
  </div>
  <ng-template #criterialLotTemplate let-tableData="tableData" let-lot="lot">
    <ng-container *ngIf="tableData.length > 0">
      <div class="col-12">
        <h2 *ngIf="projectHasLots">{{ 'TenderEvaluation.criteria.lot' | translate }} {{lot.description}}</h2>
      </div>
      <div class="col-12">
        <p-table #panel [value]="tableData" [scrollable]="true" scrollHeight="200px" frozenWidth="320px" editMode="row">
          <ng-template pTemplate="header">
            <tr>
              <th class="text-right" style="width:320px" pFrozenColumn>{{'TenderInfo.company' | translate}}</th>
              <th style="width:160px" class="text-center" *ngFor="let col of tableData[0]; index as i">
                <div class="mx-auto">
                  <span class="d-inline-block text-truncate align-middle" style="max-width: 120px;"> {{
                    (selectedCriteriaTableMode === CRITERIA_TABLE_MODE.COMPANY) ? col.criteria.name :
                    getCompanyDescription(col.tender) }}</span>
                  <button *ngIf="selectedCriteriaTableMode === CRITERIA_TABLE_MODE.COMPANY"
                    class="m-l-md btn btn-sm btn-outline-secondary" aria-expanded="false"
                    (debounceClick)="showCriteriaValorationGraph(tableData, i)" appDebounceClick>
                    <i class="fa far fa-chart-bar" aria-hidden="true"></i>
                  </button>
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td style="width:320px" pFrozenColumn>
                <div class="row m-0 w-100">
                  <div class="text-truncate col-8 p-0" style="max-width: 240px;">{{ (selectedCriteriaTableMode ===
                    CRITERIA_TABLE_MODE.COMPANY) ? getCompanyDescription(rowData[0].tender) : rowData[0].criteria.name
                    }}</div>
                  <div class="col-4 p-0">
                    <button class="btn btn-sm btn-outline-success w-100"
                      (debounceClick)="showTenderValorationGraph(rowData)" appDebounceClick> {{
                      getSumCriteria(rowData) | number: '1.2-2' }} <i class="fa fa-chart-pie" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </td>
              <td class="text-center w-160px" *ngFor="let bean of rowData">
                <button type="button" class="mx-auto btn btn-sm btn-outline-primary" aria-expanded="false"
                  (debounceClick)="editTenderCriteria(bean)" appDebounceClick>
                  <span class="d-inline-block text-truncate criteriaValue align-middle" style="max-width: 120px;"
                    *ngIf="bean.value.awardingCriteriaTypeCode"> {{ bean?.value?.weightedScoreValue | number: '1.2-2' }}
                    ( {{ bean?.value?.tenderValue | number: '1.2-2' }} ) </span>
                  <span class="d-inline-block text-truncate criteriaValue align-middle" style="max-width: 120px;"
                    *ngIf="!bean.value.awardingCriteriaTypeCode"> {{ bean?.value?.weightedScoreValue | number: '1.2-2'
                    }} </span>
                  <i class="ml-2 fa fa-pencil" aria-hidden="true"></i>
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-container>
  </ng-template>
  <!-- PANEL DE EDICION DE CRITERIO-->
  <p-dialog [resizable]="true" [(visible)]="editingCriteriaVisible" [closable]="true" [responsive]="true"
    [dismissableMask]="true" [closeOnEscape]="false" [modal]="true" [showHeader]="true" [appendTo]="'body'"
    (onHide)="closeModal()" styleClass='formEdition'
    header="{{'ProcurementProject.selectionCriteria.editForm' | translate }}" [style]="{'width':'60vh'}">
    <sub-header [isModal]="true" [windowHash]=this.criteriaWindowHash [includeContextHelp]="true">
    </sub-header>
    <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
      <div class="container-fluid" *ngIf="editingCriteriaVisible">
        <div class="row">
          <div class="col-12">
            <dl class="w-100">
              <dt></dt>
              <dd>{{ getCompanyDescription(editingCriteria.tender) }}</dd>
              <hr />
              <dt>{{ 'ProcurementProject.selectionCriteria.name' | translate }}:</dt>
              <dd>{{ editingCriteria.criteria.name }}</dd>
              <dt>{{ 'ProcurementProject.selectionCriteria.weight' | translate }}:</dt>
              <dd>{{ editingCriteria.criteria.weight }}</dd>
              <dt>{{ 'ProcurementProject.selectionCriteria.awardingCriteriaTypeCode' | translate }}:</dt>
              <dd>{{ editingCriteria.criteria.awardingCriteriaTypeCode? this.translateService.instant('General.yes') :
                this.translateService.instant('General.no') }}</dd>
              <dt *ngIf="editingCriteria.criteria.awardingCriteriaTypeCode">{{ 'TenderEvaluation.criteria.tenderValue' |
                translate }}:</dt>
              <dt *ngIf="!editingCriteria.criteria.awardingCriteriaTypeCode">{{ 'TenderEvaluation.criteria.valuation' |
                translate: {hasta: editingCriteria.criteria.weight} }}:</dt>
              <dd>
                <input type="number" pInputText pKeyFilter="num" [ngModel]="editingCriteria.value.tenderValue"
                  (change)="setTenderValue($event)" style="width:100%" min="0"
                  [max]="(editingCriteria.criteria.awardingCriteriaTypeCode) ? undefined : editingCriteria.criteria.weight" />
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </p-scrollPanel>
  </p-dialog>
  <!-- PANEL DE VISUALIZACION DE GRAFICO-->
  <p-dialog [resizable]="true" [(visible)]="chartVisible" [closable]="true" [responsive]="true" [dismissableMask]="true"
    [closeOnEscape]="true" [modal]="true" [showHeader]="true" [appendTo]="'body'" [header]="charTitle">
    <!-- <p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">-->
    <div class="container-fluid">
      <ng-container *ngIf="chartData; else loadingChart">
        <div class="row">
          <div class="col-12">
            <p-chart [responsive]="true" [type]="chartType" [data]="chartData" width="60vw" height="60vh"
              [options]="uiService.barChartOptions">
            </p-chart>
          </div>
        </div>
      </ng-container>
      <ng-template #loadingChart> {{'General.loading' | translate}}</ng-template>
    </div>
    <!-- </p-scrollPanel> -->
  </p-dialog>